module.exports = __webpack_public_path__ + "media/images/div_lens/authentic-img-973f79b2fd1ef4d8275bb33a4e2ab2ee.jpg";